var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.$attrs.class,attrs:{"href":_vm.fullHref,"target":_vm.target},domProps:{"textContent":_vm._s(_vm.href)},on:{"click":function($event){$event.stopPropagation();}}})}
var staticRenderFns = []

export { render, staticRenderFns }